import { all, fork } from 'redux-saga/effects';

import authSaga from '../../core/auth/redux/authSaga';
import commonSaga from '../../shared/redux/commonSaga';
import categorySaga from '../../features/category/redux/categorySaga';
import articleSaga from '../../features/article/redux/articleSaga';
import keywordSaga from '../../features/keyword/redux/keywordSaga';
import multimediaSaga from '../../features/multimedia/redux/multimediaSaga';
import usersSaga from '../../features/users/redux/usersSaga';

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(commonSaga),
    fork(categorySaga),
    fork(articleSaga),
    fork(keywordSaga),
    fork(multimediaSaga),
    fork(usersSaga),
  ]);
}
